export default __webpack_public_path__ + "edb54a591f5378b699a98cc8f4684134.svg";